module.exports = __webpack_public_path__ + "img/impressive_jewelry.aa865f7.jpg";